var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 vw-100 overflow-auto text-center"},[_c('img',{attrs:{"src":"/Frequency-Reference-Chart-2020-12-23-011.png"}})])}]

export { render, staticRenderFns }